<template>
  <WebChapterTemplate
    page-title="学术成果掠影"
    section-label="学科建设"
    :section-route="sectionRoute"
    :top-strip-image="topStripImage"
    :hero-background-image="heroBackgroundImage"
  >
    <div class="achievement-manual">
      <section
        v-for="section in sections"
        :key="section.title"
        class="achievement-section"
      >
        <div class="achievement-section__header">
          <h2 class="achievement-section__title">{{ section.title }}</h2>
        </div>

        <div
          class="achievement-gallery"
          :class="`achievement-gallery--${section.images.length}`"
        >
          <figure
            v-for="image in section.images"
            :key="image.src"
            class="achievement-figure"
          >
            <img :src="image.src" :alt="image.alt" loading="lazy" />
          </figure>
        </div>

        <ul
          class="achievement-list"
          :class="{ 'achievement-list--two-columns': section.twoColumns }"
        >
          <li
            v-for="entry in section.entries"
            :key="entry"
            class="achievement-list__item"
          >
            {{ entry }}
          </li>
        </ul>
      </section>
    </div>
  </WebChapterTemplate>
</template>

<script>
import WebChapterTemplate from '@/components/WebChapterTemplate.vue';

export default {
  name: 'LanhuZhengwenyexueshuchengguo',
  components: {
    WebChapterTemplate
  },
  data() {
    return {
      sectionRoute: '/lanhu_xuekeyukeyan',
      topStripImage: require('@/views/lanhu_jigouyulishi/assets/img/SketchPnge6526ecb2fcab0802b546f04824fe8f83db80e06fef6b8cf3b08d187c494f182.png'),
      heroBackgroundImage: require('@/views/lanhu_zhengwenyexueshuchengguo/assets/img/173301bb9c6d42d7ae3028c182487260_mergeImage.png'),
      sections: [
        {
          title: '马克思主义新闻观',
          images: [
            {
              src: require('./assets/html/marxism-overview.jpg'),
              alt: '马克思主义新闻观代表著作'
            }
          ],
          entries: [
            '《中国共产党新闻工作文件汇编》（上、中、下卷），中国社会科学院新闻研究所编，新华出版社，1980 年',
            '《精神交往论——马克思恩格斯的传播观》，陈力丹著，开明出版社，1993 年',
            '《马克思主义新闻学词典》，陈力丹著，中国广播电视出版社，2002 年',
            '《马克思、恩格斯、列宁、斯大林论新闻出版》，尹韵公主编，中国社会科学出版社，2012 年',
            '《马克思主义新闻传播史论的研究历程》（第一、第二、第三卷），中国社会科学院新闻与传播研究所马克思主义新闻学研究室编，中国社会科学出版社，2013 年、2014 年、2015 年'
          ]
        },
        {
          title: '新闻理论',
          images: [
            {
              src: require('./assets/html/journalism-theory.jpg'),
              alt: '新闻理论代表著作'
            }
          ],
          entries: [
            '《新闻论集》，安岗著，天津人民出版社，1982 年',
            '《各国新闻出版法选辑》，中国社会科学院新闻研究所等编，人民日报出版社，1981 年',
            '《各国广播电视法选辑》，钱辛波、姜宇辉、张宗厚、曾美云编，群众出版社，1984 年',
            '《各国新闻出版法选辑》（续编），中国社会科学院新闻研究所、北京新闻学会等编，人民日报出版社，1987 年',
            '《新闻侵权与诉讼》，孙旭培主编，人民日报出版社，1994 年',
            '《媒介消费之讼——中国内地案例重述与释解》，宋小卫著，中国社会科学出版社，2009 年',
            '《喻权域文集》，喻权域著，上海辞书出版社，2005 年',
            '《张力与限制——新闻法治与自律的比较研究》，张西明著，重庆出版社，2002 年'
          ],
          twoColumns: true
        },
        {
          title: '应用新闻学',
          images: [
            {
              src: require('./assets/html/applied-journalism.jpg'),
              alt: '应用新闻学代表著作'
            }
          ],
          entries: [
            '《标题的艺术》，彭朝丞著，人民日报出版社，1985 年',
            '《十年新闻写作变革》，何光先著，中国新闻出版社，1989 年',
            '《致青年记者 60 封信》，商恺著，经济日报出版社',
            '《报业经济与报业经营》，唐绪军著，新华出版社，1999 年',
            '《新中国传媒 50 年》，中国新闻年鉴编辑委员会编辑，中国新闻年鉴社，2000 年',
            '《中国传媒集团发展报告》，《中国传媒集团发展报告》课题组编，湖南教育出版社，2004 年'
          ],
          twoColumns: true
        },
        {
          title: '新闻史',
          images: [
            {
              src: require('./assets/html/history-of-journalism.jpg'),
              alt: '新闻史代表著作'
            }
          ],
          entries: [
            '《日本报业简史》，宁新著，中国社会科学出版社，1981 年',
            '《新华日报史：1938—1947》，韩辛茹著，重庆出版社，1987 年',
            '《世界十国新闻史纲要》，陶涵主编，文津出版社，1989 年',
            '《〈大公报〉与现代中国》，方蒙著，重庆出版社，1993 年',
            '《延安〈解放日报〉史》，王敬主编，新华出版社，1998 年',
            '《尹韵公自选集》，尹韵公著，学习出版社，2009 年'
          ],
          twoColumns: true
        },
        {
          title: '传播学',
          images: [
            {
              src: require('./assets/html/communication-studies-a.jpg'),
              alt: '传播学代表著作（一）'
            },
            {
              src: require('./assets/html/communication-studies-b.jpg'),
              alt: '传播学代表著作（二）'
            }
          ],
          entries: [
            '《传播学（简介）》，中国社会科学院新闻研究所世界新闻研究室编，人民日报出版社，1983 年',
            '《北京读者听众观众调查》，北京新闻学会调查组编，工人出版社，1985 年',
            '《塑造形象的艺术：公共关系学概论》，中国社会科学院新闻研究所公共关系课题组编著，科学普及出版社，1986 年',
            '《西方新闻理论评析》，徐耀魁主编，新华出版社，1998 年',
            '《中国传播效果透视》，陈崇山、弥秀玲主编，沈阳出版社，1989 年',
            '《华夏传播论：中国传统文化中的传播》，孙旭培主编，人民出版社',
            '《电视影响评析》，时统宇著，新华出版社，1999 年',
            '《社会科学成果价值评估》，卜卫、周海宏、刘晓红著，社会科学文献出版社，1999 年',
            '《大众传播心理研究》，刘晓红、卜卫著，中国广播电视出版社，2001 年',
            '《人与人的相遇：人际传播论》，王怡红著，人民出版社，2003 年',
            '《跨文化传播的后殖民语境》，姜飞著，中国人民大学出版社，2005 年',
            '《中国新闻年鉴·传媒调查卷》，中国社会科学院新闻与传播研究所编，刘志明主编，中国新闻年鉴社，2005 年',
            '《中国传播学 30 年：1978-2008》，王怡红、胡翼青主编，中国大百科全书出版社，2010 年',
            '《电视娱乐：传播形态及社会影响研究》，殷乐著，中国社会科学出版社，2011 年'
          ],
          twoColumns: true
        },
        {
          title: '新媒体研究',
          images: [
            {
              src: require('./assets/html/new-media-research.jpg'),
              alt: '新媒体研究成果与获奖展示'
            }
          ],
          entries: [
            '《传播科技纵横》，闵大洪著，警官教育出版社，1998 年',
            '《信息高速公路与大众传播》，明安香著，华夏出版社，1999 年',
            '《网络互动：意义诠释与规则探讨》，孟威著，经济管理出版社，2004 年',
            '《新媒体：融合与发展》，黄楚新著，人民日报出版社，2015 年',
            '2017 年 9 月，第七届吴玉章人文社会科学奖举行颁奖典礼，新闻与传播研究所学者获得青年奖一等奖',
            '2013 年 1 月，所领导为所优秀科研成果奖获得者颁奖',
            '从 2014 年至 2018 年，新媒体蓝皮书连续 5 年获得优秀皮书'
          ]
        }
      ]
    };
  }
};
</script>

<style scoped>
.achievement-manual {
  display: grid;
  gap: 32px;
}

.achievement-section {
  padding: 26px;
  border-radius: 12px;
  border: 1px solid rgba(179, 145, 101, 0.18);
  background:
    linear-gradient(140deg, rgba(248, 242, 233, 0.84), rgba(255, 255, 255, 0) 42%),
    linear-gradient(180deg, #fff, rgba(253, 250, 246, 0.96));
  box-shadow: 0 14px 30px rgba(59, 41, 17, 0.05);
}

.achievement-section__header {
  margin-bottom: 22px;
  padding-bottom: 14px;
  border-bottom: 1px solid rgba(179, 145, 101, 0.16);
}

.achievement-section__title {
  margin: 0;
  color: #f25c19;
  font-size: 26px;
  line-height: 1.4;
  font-family: 'Songti SC', 'STSong', 'Noto Serif SC', serif;
  font-weight: 700;
}

.achievement-gallery {
  display: grid;
  gap: 18px;
  margin-bottom: 24px;
}

.achievement-gallery--2 {
  grid-template-columns: repeat(2, minmax(0, 1fr));
}

.achievement-figure {
  margin: 0;
  overflow: hidden;
  border-radius: 12px;
  border: 1px solid rgba(179, 145, 101, 0.16);
  background: #fff;
  box-shadow: 0 10px 24px rgba(45, 33, 16, 0.05);
}

.achievement-figure img {
  display: block;
  width: 100%;
  height: auto;
}

.achievement-list {
  display: grid;
  gap: 12px;
  margin: 0;
  padding: 0;
  list-style: none;
}

.achievement-list--two-columns {
  grid-template-columns: repeat(2, minmax(0, 1fr));
  column-gap: 28px;
}

.achievement-list__item {
  position: relative;
  padding-left: 18px;
  color: #2f2a25;
  font-size: 17px;
  line-height: 1.9;
  font-family: 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei', sans-serif;
}

.achievement-list__item::before {
  content: '';
  position: absolute;
  left: 0;
  top: 0.82em;
  width: 6px;
  height: 6px;
  border-radius: 999px;
  background: rgba(242, 92, 25, 0.82);
}

@media (max-width: 1024px) {
  .achievement-gallery--2,
  .achievement-list--two-columns {
    grid-template-columns: 1fr;
  }
}

@media (max-width: 768px) {
  .achievement-section {
    padding: 18px;
  }

  .achievement-section__title {
    font-size: 24px;
  }

  .achievement-list__item {
    font-size: 16px;
    line-height: 1.8;
  }
}
</style>
